/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _|
 | |_| | | | | |_) || |  / / | | |  \| | | | | || |
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___|

=========================================================
* Horizon UI - v1.0.0
=========================================================

* Product Page: https://www.horizon-ui.com/
* Copyright 2022 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chakra imports
import {
  Box,
  Flex,
  Icon,
  SimpleGrid,
  useColorModeValue
} from "@chakra-ui/react";

// Custom components
import { useGetAccountInfo, useGetLoginInfo } from "@multiversx/sdk-dapp/hooks";
import axios from "axios";
import Course from "components/card/Course";
import MiniStatistics from "components/card/MiniStatistics";
import YourCard from "components/card/YourCard";
import IconBox from "components/icons/IconBox";
import { VSeparator } from "components/separator/Separator";
import queryString from 'query-string';
import React, { useEffect, useState } from "react";
import { GiAstronautHelmet, GiWallet } from "react-icons/gi";


export default function UserReports() {
  const [holderCount, setholderCount] = useState();
  const [avgPrice, setAvgPrice] = useState();
  // const [totalTrade, setTotalTrades] = useState();
  const [totalVolume, setTotalVolume] = useState();
  const { address } = useGetAccountInfo();
  const { tokenLogin, loginMethod } = useGetLoginInfo();
  const isLoggedIn = Boolean(address);

  const brandColor = useColorModeValue("brand.500", "white");
  const paleGray = useColorModeValue("secondaryGray.400", "whiteAlpha.100");

  useEffect(async () => {
    const response = await axios.get(`https://proxy-api.xoxno.com/getCollectionProfile/ASTRONAUTS-22c98a`)
        .catch(e => console.error(e));
    const data = response?.data;
    setTotalVolume(data.statistics.tradeData.totalEgldVolume + 464);
    setAvgPrice(data.statistics.tradeData.averageEgldPrice);
  }, [])

  useEffect(async () => {
    const response = await axios.get(`https://proxy-api.xoxno.com/getCollectionOwners/ASTRONAUTS-22c98a`)
      .catch(e => console.error(e));
    const data = response?.data?.hodlersInfo?.uniqueHodlers || '?';
    setholderCount(data);
  }, [])

  React.useEffect(() => {

    let signature = null;
    if( loginMethod == 'wallet' ) {
        signature = queryString.parse(window.location.href).signature;
    } else {
        signature = tokenLogin?.signature;
    }

    if( signature ) {
      localStorage.setItem("signature", signature);
    }

  }, []);

  function roundDecimal(nombre, precision) {
    const _precision = precision || 2;
    const tmp = Math.pow(10, _precision);
    return Math.round(nombre * tmp) / tmp;
  }

  return (

    <Flex
      direction={{ base: "column", xl: "row" }}
      pt={{ base: "130px", md: "80px", xl: "80px" }}
      justifyContent='space-around'>
      <Box width={'100%'}>

        <SimpleGrid
          columns={{ base: 1, md: 2, lg: 2, "2xl": 4, "3xl": 4 }}
          gap='20px'
          mb='20px'>
          <MiniStatistics
            startContent={
              <IconBox
                w='56px'
                h='56px'
                bg='linear-gradient(135deg, #efbc5e 0%, #e1871e 100%)'
                icon={
                  <Icon w='32px' h='32px' as={GiAstronautHelmet} color={brandColor} />
                }
              />
            }
            name='Astronauts'
            value='3018'

          />
          <MiniStatistics
            startContent={
              <IconBox
                w='56px'
                h='56px'
                bg='linear-gradient(135deg, #efbc5e 0%, #e1871e 100%)'
                icon={
                  <Icon w='32px' h='32px' as={GiWallet} color={brandColor} />
                }
              />
            }
            name='Number of holders'
            value={holderCount}
          />
          <MiniStatistics name='Average Price (EGLD)' value={roundDecimal(avgPrice, 0)} />
          <MiniStatistics name='Volume (EGLD)' value={roundDecimal(totalVolume, 1)} />
        </SimpleGrid>
        <SimpleGrid columns='1' gap='20px'>
        <Course
            title='xSafe has been configured this morning'
            desc="5 Members of the council have access to xSafe address and any movement or any action must be validate by 3 of them, in other words our entire wallet is safe. This decision is part of a fully DAO ! For now 300 egld has been staked with truststaking (to benefit Xoxno air drop) !"
            day='Tue'
            date='March 28, 2023'
            topics={["dao"]}
            time='1h 30 min'
          />
        <Course
            title='Elrond Moon Mission becomes xApollo'
            desc="We are pleased to inform you that Elrond Moon Mission becomes xApollo. While the rebranding DAO vote was finished we couldn't wait to announce our new name ! It's for all of us a new fresh start for this project ! Much more is coming ! 🔥"
            day='Mon'
            date='March 27, 2023'
            topics={["dao"]}
            time='1h 30 min'
          />
        </SimpleGrid>
      </Box>
      {isLoggedIn && (
        <>
          <VSeparator
            mx='20px'
            bg={paleGray}
            mt={{ md: '20px' }}
            width={{ xl: '1px', lg: 'auto' }}
            height={{ xl: 'auto', lg: '1px' }}
            display={{ xl: "flex" }}
          />
          <YourCard
            mt={{ md: "0px", xl: "0px" }}
            maxW={{ base: "100%", xl: "400px" }}
            maxH={{ base: "100%", xl: "1170px", "2xl": "100%" }}
          />
        </>
      )}
    </Flex>
  );
}
